module.exports = __webpack_public_path__ + "static/img/product-luolan.6a9a02f9.png";